
import { localStorageManager } from '../storage/local-storage.js';

export function saveFilter(key, value) { try { localStorageManager.saveFilter(key, value); } catch(_) {} }
export function loadFilters() { try { return localStorageManager.loadFilters(); } catch(_) { return null; } }
export function clearFilters() { try { localStorageManager.clearFilters(); } catch(_) {} }


